import './loader.css'

const ButtonLoader = () => {

    return (
        <div className="btn-loader"></div>
    )
}

export default ButtonLoader;